import { apiClient } from './apiClient';
import { authService } from './authService';

const getCompanyParam = () => {
  const companyId = authService.getCompanyId();
  return companyId ? `companyId=${companyId}` : '';
};

export const visitService = {
  // Get all visits
  async getVisits() {
    return apiClient.get(`/api/cmms/visits?${getCompanyParam()}`);
  },

  // Get visits by contract
  async getVisitsByContract(contractId) {
    return apiClient.get(`/api/cmms/visits/contract/${contractId}?${getCompanyParam()}`);
  },

  // Get visits by status
  async getVisitsByStatus(status) {
    return apiClient.get(`/api/cmms/visits/status/${status}?${getCompanyParam()}`);
  },

  // Get upcoming visits
  async getUpcomingVisits() {
    return apiClient.get(`/api/cmms/visits/upcoming?${getCompanyParam()}`);
  },

  // Get overdue visits
  async getOverdueVisits() {
    return apiClient.get(`/api/cmms/visits/overdue?${getCompanyParam()}`);
  },

  // Get visits between dates
  async getVisitsBetweenDates(startDate, endDate) {
    return apiClient.get(`/api/cmms/visits/between?${getCompanyParam()}&startDate=${startDate}&endDate=${endDate}`);
  },

  // Get single visit by ID
  async getVisitById(id) {
    return apiClient.get(`/api/cmms/visits/${id}?${getCompanyParam()}`);
  },

  // Create new visit
  async createVisit(data) {
    return apiClient.post(`/api/cmms/visits?${getCompanyParam()}`, data);
  },

  // Update visit
  async updateVisit(id, data) {
    return apiClient.put(`/api/cmms/visits/${id}?${getCompanyParam()}`, data);
  },

  // Update visit status
  async updateVisitStatus(id, status, actualDate = null, notes = null) {
    return apiClient.put(`/api/cmms/visits/${id}/status?${getCompanyParam()}`, {
      status,
      actualDate,
      notes,
    });
  },

  // Delete visit
  async deleteVisit(id) {
    return apiClient.delete(`/api/cmms/visits/${id}?${getCompanyParam()}`);
  },
};
